import { render, staticRenderFns } from "./ClienteFormulario.vue?vue&type=template&id=6a5951cb"
import script from "./ClienteFormulario.vue?vue&type=script&lang=js"
export * from "./ClienteFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports